<template>
  <div>
    <grid
      ref="eventsGrid"
      :add-checkmarks="true"
      :edit-action-as-link="false"
      :list-url="listUrl"
      loading-message="Loading events ..."
      :show-header="true"
      @selected-items-changed="onSelectedItemsChanged"
    >
      <template #header>
        <a
          href="#"
          :class="['btn btn-sm btn-primary me-2', { 'soft-disabled': !hasSelectedItems }]"
          @click.prevent="generateAssessmentReport"
        >
          Assessment report (docx)
        </a>
      </template>
    </grid>
  </div>
</template>
<script setup lang="ts">
import {ref, useTemplateRef} from 'vue'
import Grid from "./grid.vue"
import {isPresent} from "../js-utils"

const props = defineProps({
  listUrl: {required: true, type: String},
  reportUrl: {required: true, type: String}
})

const hasSelectedItems = ref(false)

const eventsGrid = useTemplateRef('eventsGrid')

const onSelectedItemsChanged = (): void => {
  hasSelectedItems.value = (eventsGrid.value?.selectedItemIds?.length ?? 0) > 0
}

const generateAssessmentReport = (): void => {
  const selectedEventIds = eventsGrid.value?.selectedItemIds || []
  if (selectedEventIds.length == 0) {
    alert('Please select at least one event')
    return
  }

  eventsGrid.value?.performRequest(props.reportUrl, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    event_ids: selectedEventIds
  }, null, (status, response) => {
    if (status) {
      if (isPresent(response.url)) {
        window.location.href = response.url
      }
    }
  })
}
</script>
